<template>
  <div class="animated fadeIn" v-if="show">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        WEBCastle Detect/Block Log
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Log</a>
        </li>
      </ul>
    </div>
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_from">Detected_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-2" size="sm" variant="outline-primary" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'created_at')">1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'created_at')">1M</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">Group Name</label>
        </b-col>
        <b-col v-if="group_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="group_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">Clear</b-button>
          </b-form-group>
        </b-col>
        <b-col v-if="!group_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-button :variant="group_name ? 'primary' : 'add'" @click="chainGroup = true">Select Group</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-4">
          <label class="col-form-label">Response</label>
        </b-col>
        <b-col classs="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <b-form-group>
            <input class="mt-3" type="radio" id="DetectionOnly" value=false v-model="so.opt.is_block" @click="so.sk='is_block'">
            <label for="DetectionOnly">
              <b-badge variant="warning">Detection</b-badge>
            </label>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <b-form-group>
            <input class="mt-3" type="radio" id="Block" value=true v-model="so.opt.is_block" @click="so.sk='is_block'">
            <label for="Block">
              <b-badge variant="danger">Block</b-badge>
            </label>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-4">
          <label class="col-form-label">Method</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <b-form-group>
            <input type="radio" id="GET" value="GET" v-model="so.opt.method" @click="so.sk='request'">
            <label class="col-form-label" for="GET">GET</label>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <b-form-group>
            <input type="radio" id="POST" value="POST" v-model="so.opt.method" @click="so.sk='request'">
            <label for="POST">POST</label>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_rule_id">Rule ID</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_rule_id" v-model="so.opt['m_id']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 dol-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_rule_line">Rule Line</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_rule_line" v-model="so.opt['m_line']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_rule_file">Rule File</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_rule_file" v-model="so.opt['m_file']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_message">Message anything</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_message" v-model="so.opt['message']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_headers">Header anything</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_headers" v-model="so.opt['headers']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_attacker">Attacker</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_attacker" v-model="so.opt['remote_addr']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_victim">Victim</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_victim" v-model="so.opt['target']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">Match Type</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">Match all</b-form-radio>
              <b-form-radio value="or">Match at least one</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-4">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col sm="2">
        <span class="badge badge_border_primary mb-2">Total: <span style="padding-left: 2.2rem"></span>{{ (summaryData.total ? summaryData.total : 0).toString().padStart(10, nbsp) | number }}</span>
        <br>
        <span class="badge badge_border_info mb-2">Block: <span style="padding-left: 2rem"></span>{{ (summaryData.disable ? summaryData.disable : 0).toString().padStart(10, nbsp) | number }}</span>
        <br>
        <span class="badge badge_border_warning mb-2">Detected: <span style="padding-left: 0.5rem"></span>{{ (summaryData.enable ? summaryData.enable : 0).toString().padStart(10, nbsp) | number }}</span>
      </b-col>
      
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mb7 form-inline">
            <label class="col-form-label mr-2" for="sel3">Search Range</label>
            <div class="input-group">
              <date-picker @change="refresh" v-model="so.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </div>
            <span class="mx-2">~</span>
            <div class="input-group">
              <date-picker @change="refresh" v-model="so.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </div>
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
          </div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
              <option disabled value="">Search</option>
              <option value="group.groupname">Group</option>
              <option value="remote_addr">Attacker</option>
              <option value="target">Victim</option>
              <option value="uri">URI</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input class="form-control col-xl-12" :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus"></i>
            </button> -->
          </div>
        </b-input-group>
      </b-col>
    </div>
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list"
            show-empty empty-text="not found" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" @row-clicked="goDetail" style="cursor:pointer;">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="group.groupname" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.group ? row.item.group.groupname : '-'}}</del>
              <span v-else>{{row.item.group ? row.item.group.groupname : '-'}}</span>
            </template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
            <template slot="remote_addr" slot-scope="row">{{row.item.remote_addr ? row.item.remote_addr : '-'}}</template>
            <template slot="target" slot-scope="row">
              <!-- {{row.item.target.replace(/::ffff:/, '')}} -->
              {{row.item.target ? (row.item.target.replace(/::ffff:/, '')) : '-'}}
              {{ !row.item.target && row.item.reqTarget ? '/' + row.item.reqTarget : ''}}
            </template>
            <template slot="protocol" slot-scope="row">{{row.item.protocol}}({{row.item.method}})</template>
            <template slot="is_block" slot-scope="row">
              <b-badge v-if="row.item.is_block" variant="danger">Block</b-badge>
              <b-badge v-else variant="warning">Detect</b-badge>
            </template>
            <template slot="severity" slot-scope="row">
              <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(row.item.severity, 'variant')">
                {{codes.WAF_SEVERITY_TO_DESC_EASY(row.item.severity, 'EN')}}
              </b-badge>
              <!-- <b-badge v-if="row.item.severity >= 5" variant="danger">CRITICAL</b-badge>
              <b-badge v-else-if="row.item.severity >= 4" variant="warning">ERROR</b-badge>
              <b-badge v-else-if="row.item.severity >= 3" variant="warning">WARNING</b-badge>
              <b-badge v-else-if="row.item.severity >= 2" variant="dark">NOTICE</b-badge>
              <b-badge v-else variant="primary">Info</b-badge> -->
              <!--<b-badge v-else variant="primary">Normal</b-badge>-->
              <!-- // # - CRITICAL severity: Anomaly Score of 5. Mostly generated by the application attack rules (93x and 94x files).
              // # - ERROR severity: Anomaly Score of 4. Generated mostly from outbound leakage rules (95x files).
              // # - WARNING severity: Anomaly Score of 3. Generated mostly by malicious client rules (91x files).
              // # - NOTICE severity: Anomaly Score of 2. Generated mostly by the protocol rules (92x files). -->
            </template>
            <template slot="uri" slot-scope="row">
              <div v-if="row.item.uri">
                {{row.item.uri | truncate(60) }}
              </div>
              <div v-else>
                -
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-row class="mt30">
      <b-col class="pagination justify-content-center">
        <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"/>
      </b-col>
<!--         <b-col class="md-4">
        <div class="pull-right">
          <b-button size="sm" variant="success" @click="$router.push('/site/add')"> 신규 등록 </b-button>
        </div>
      </b-col> -->
    </b-row>

    <!-- start connect group modal -->
    <b-modal title="Find then Group and Select" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>

    <!-- 시작 및 마지막 날짜 유무 확인 모달-->
    <b-modal title="Search Range Setting" size="xs" v-model="date_modal" @ok="date_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      Please specify start and end dates.
    </b-modal>

    <!-- 기간 설정 범위제한 모달-->
    <b-modal title="Search Range Setting" size="xs" v-model="year_modal" @ok="year_modal = false" ok-variant="outline-info" ok-only>
      WEBCastle Detect/Block Log can be viewed in units of up to 1 year.
    </b-modal>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>